import React, { useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import './App.css';
import Layout from './components/Layout';
import ResponsivePortfolioComponent from './views/pages/Portfolio/ResponsivePortfolioComponent.js';
import ResponsiveProfileComponent from './views/pages/Portfolio/ResponsiveProfileComponent.js';
import { getStoredConsent, sendPageView, updateConsent } from './lib/analytics';

/**
 * RouteTracker — listens to React Router navigation and fires page_view
 * events. Only sends data when analytics_storage has been granted by the user.
 * Must be rendered inside <BrowserRouter>.
 */
function RouteTracker() {
  const location = useLocation();

  useEffect(() => {
    const stored = getStoredConsent();
    // Only send page views when the user has explicitly accepted
    if (stored && stored.decision === 'accepted') {
      sendPageView(location.pathname + location.search);
    }
  }, [location]);

  return null;
}

function App() {
  // Restore previously stored consent on app mount
  useEffect(() => {
    const stored = getStoredConsent();
    if (stored) {
      updateConsent(stored.decision === 'accepted');
    }
    // Note: ReactGA.initialize() has been removed.
    // GA4 is now initialised in public/index.html via gtag.js with Consent Mode v2.
    // The GA4 Measurement ID is set via REACT_APP_GA_ID environment variable.
  }, []);

  return (
    <Router>
      <RouteTracker />
      <Routes>
        <Route path="*" element={<Layout />}></Route>
        <Route path='/portfolio/:uuid' element={<ResponsivePortfolioComponent />}></Route>
        <Route path='/profile/:uuid' element={<ResponsiveProfileComponent />}></Route>
      </Routes>
    </Router>
  );
}

export default App;
